import { useMemo } from 'react';
import { useParams } from 'react-router';
import type { FeeOverviewRouteParams } from '../_types';

export function useFeesOverviewRouteParams() {
  const { tabValue, feeType = 'commissions' } =
    useParams<FeeOverviewRouteParams>();

  return useMemo(() => ({ feeType, tabValue }), [feeType, tabValue]);
}
